'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import MobilePanelHeader from 'marketplace-ui-common/components/mobile/MobilePanelHeader';
import { Fragment } from 'react';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterDrilldownPanelWrapper = ({
  applyFilters,
  children,
  onPanelClose,
  title
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
      itemLeft: /*#__PURE__*/_jsxs(Button, {
        autoFocus: true,
        use: "transparent",
        onClick: () => onPanelClose(false),
        padding: "100",
        children: [/*#__PURE__*/_jsx(LeftIcon, {
          color: "do-not-use-calypso",
          size: "600"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'ecosystem-marketplace-solutions-ui.storefront.filters.allFilters'
        })]
      }),
      itemRight: /*#__PURE__*/_jsx(Button, {
        padding: "100",
        paddingInlineEnd: "300",
        use: "transparent",
        onClick: applyFilters,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'ecosystem-marketplace-solutions-ui.storefront.filters.apply'
        })
      }),
      title: title
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsx(PanelSection, {
        children: children
      })
    })]
  });
};
export default FilterDrilldownPanelWrapper;